import { ITheme, ThemeFont } from "../../types";

// The font family for the apps is referenced differently than the web fonts

export const fonts: Record<keyof ITheme["fonts"], ThemeFont> = {
    regular: {
        fontFamily: "Nunito Sans Variable",
        fontWeight: "300", // Note: 300 is lighter than the "default" of 400 - this makes less space for lighter variants. See below.
    },
    medium: {
        fontFamily: "Montserrat Variable",
        fontWeight: "700",
    },
    light: {
        fontFamily: "Nunito Sans Variable",
        fontWeight: "300", // Note: 300 is the same weight as "regular" - which effectively means, that we have no "light" font variant.
    },
    thin: {
        fontFamily: "Nunito Sans Variable",
        fontWeight: "200", // Note: 200 is the lowest weight for Nunito Sans - which means, there is no room for an extra size between "regular" and "thin", since "regular" is weight 300.
    },
    monospace: {
        fontFamily: "monospace",
    },
};
